module.exports = __webpack_public_path__ + "static/media/ic_ai.9a4442ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_ai.svg
// module id = 303
// module chunks = 0